export const favorites = {
  title: "Mes favoris",
  subtitle: "{{count}} logements sauvegardés",
  countries: "Pays",
  cities: "Villes",
  emptyTitle: "Aucun favori pour le moment",
  emptyFiltered: "Essayez de modifier vos filtres pour voir vos favoris.",
  emptyState:
    "Explorez nos logements uniques et ajoutez-les à vos favoris pour les retrouver ici.",
  noFavoritesYet: "Aucun favori pour le moment",
  exploreMembersMap: "Explorez la carte des membres pour trouver des logements",
  exploreMap: "Explorer la carte",
  backToHome: "Retour à l'accueil",
  howToAddFavorites: "Comment ajouter des favoris ?",
  step1: "Rendez-vous sur la",
  step2: "carte des membres",
  step3: "et cliquez sur le cœur",
  step3End: "pour ajouter un logement à vos favoris",
  membersMapLink: "Carte des membres",
  properties: "propriétés",
  selected: "sélectionnées",
  compare: "Comparer",
  actions: "Actions",
  contact: "Contacter",
  exchange: "Proposer un échange",
  removeFromFavorites: "Retirer des favoris",
  removeFromComparison: "Retirer de la comparaison",
  owner: "Propriétaire",
  ratingLabel: "Note",
  exchangesLabel: "Échanges",
  exchangesCount: "échanges",
  exchangesCompleted: "échanges réalisés",
  capacityLabel: "Capacité",
  guestsCount: "voyageurs",
  numberOfRooms: "chambres",
  roomsCount: "chambres",
  onlineStatus: "En ligne",
  onlineBadge: "En ligne",
  verifiedStatus: "Vérifié",
  verifiedBadge: "Vérifié",
  no: "Non",
};
